import React from "react";
import styled from "@mui/material/styles/styled";
import { GenericButton } from "./genericButton";
import { PatientColorMap } from "../../layout/patientColorMap";
import InfoOutlinedIcon from "@mui/icons-material/Info";
import { useTranslate } from "../../hooks/useTranslate";
import { onRtl } from "fe-web-components/rtl/rtlStyles";
//region [[ Styles ]]
const MoreAboutDiseaseButtonContainer = styled("div")({
  display: "flex",
  marginTop: "15px",
  flexFlow: "row-reverse",
  alignItems: "center",
  width: "100%",
});

const MoreAboutDiseaseBtn = styled(GenericButton)({
  "&.generic-button": {
    height: "35px",
    borderRadius: "40px",
    background: PatientColorMap.Primary,
    "&:hover, &.clicked": {
      background: PatientColorMap.Primary,
      color: "white",
    },
    color: "white",
  },
});

const InfoIcon = styled(InfoOutlinedIcon)({
  fontSize: "30px",
  //TODO: Remove !important !! try "&.svg" to win specificity
  margin: "0px 5px 0px -10px !important",
  ...onRtl({
    margin: "0px -10px 0px 5px !important",
  }),
});
//endregion [[ Styles ]]

//region [[ Props ]]
interface MoreAboutDiseaseButtonProps {
  onClick: (e: any) => void;
  className?: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MoreAboutDiseaseButton = ({
  onClick,
  className,
}: MoreAboutDiseaseButtonProps) => {
  const { translate } = useTranslate();

  return (
    <MoreAboutDiseaseButtonContainer className={className}>
      <MoreAboutDiseaseBtn
        onClick={onClick}
        label={translate("MORE_ABOUT_DISEASE")}
        icon={<InfoIcon />}
      />
    </MoreAboutDiseaseButtonContainer>
  );
};
